import { Controller } from "@hotwired/stimulus";

// Autocomplete de mentions @ dans un champ Trix. Détecte un token `@requête`
// avant le curseur, interroge /mentionables/search (scopé junior), affiche un
// menu, et insère un LIEN Trix natif vers l'entité (survit à Trix + ActionText).
export default class extends Controller {
  static values = { searchUrl: String };

  connect() {
    this.editor = this.element.querySelector("trix-editor");
    if (!this.editor) return;
    this._onKeyup = this._handleKeyup.bind(this);
    this.editor.addEventListener("trix-initialize", () => {});
    this.editor.addEventListener("keyup", this._onKeyup);
    this.editor.addEventListener("blur", () => setTimeout(() => this._close(), 200));
    this._build();
  }

  disconnect() {
    this.editor?.removeEventListener("keyup", this._onKeyup);
    this.dropdown?.remove();
  }

  _build() {
    this.dropdown = document.createElement("div");
    Object.assign(this.dropdown.style, {
      position: "absolute", zIndex: 1000, background: "#fff", border: "1px solid #e5e7eb",
      borderRadius: "8px", boxShadow: "0 4px 16px rgba(0,0,0,.12)", maxHeight: "240px",
      overflow: "auto", minWidth: "240px", display: "none", fontSize: ".9rem",
    });
    document.body.appendChild(this.dropdown);
  }

  async _handleKeyup(e) {
    if (this._open && ["ArrowDown", "ArrowUp", "Enter", "Escape"].includes(e.key)) {
      this._navKeys(e);
      return;
    }
    const ed = this.editor.editor;
    const pos = ed.getSelectedRange()[1];
    const text = ed.getDocument().toString().slice(0, pos);
    const m = text.match(/@([\p{L}0-9 ._'-]{1,40})$/u);
    if (!m) return this._close();
    this._matchStart = pos - m[0].length;
    this._matchEnd = pos;
    await this._fetch(m[1].trim());
  }

  async _fetch(q) {
    if (!q) return this._close();
    try {
      const res = await fetch(`${this.searchUrlValue}?q=${encodeURIComponent(q)}`, { headers: { Accept: "application/json" } });
      this._render(await res.json());
    } catch (_) { this._close(); }
  }

  _render(items) {
    if (!Array.isArray(items) || !items.length) return this._close();
    this._items = items;
    this._active = 0;
    this.dropdown.innerHTML = items.map((it, i) => `
      <div class="bm-item" data-idx="${i}" style="padding:.4rem .6rem; cursor:pointer; ${i === 0 ? "background:#eff6ff;" : ""}">
        <span style="font-size:.7rem; color:#2563eb; font-weight:600;">${this._esc(it.type)}</span>
        <span> ${this._esc(it.label)}</span>
      </div>`).join("");
    this.dropdown.querySelectorAll(".bm-item").forEach(el => {
      el.addEventListener("mousedown", ev => { ev.preventDefault(); this._select(parseInt(el.dataset.idx, 10)); });
    });
    this._position();
    this.dropdown.style.display = "block";
    this._open = true;
  }

  _position() {
    const r = this.editor.getBoundingClientRect();
    this.dropdown.style.left = `${window.scrollX + r.left}px`;
    this.dropdown.style.top = `${window.scrollY + r.bottom + 4}px`;
  }

  _navKeys(e) {
    if (e.key === "Escape") return this._close();
    if (e.key === "Enter") { e.preventDefault(); return this._select(this._active); }
    e.preventDefault();
    const n = this._items.length;
    this._active = (this._active + (e.key === "ArrowDown" ? 1 : -1) + n) % n;
    this.dropdown.querySelectorAll(".bm-item").forEach((el, i) => { el.style.background = i === this._active ? "#eff6ff" : ""; });
  }

  _select(idx) {
    const it = this._items?.[idx];
    if (!it) return;
    const ed = this.editor.editor;
    // Sélectionne le token @requête puis le remplace par un lien (Trix remplace
    // la sélection à l'insertion).
    ed.setSelectedRange([this._matchStart, this._matchEnd]);
    ed.insertHTML(`<a href="${this._esc(it.url || "#")}">@${this._esc(it.label)}</a> `);
    this._close();
    this.editor.focus();
  }

  _close() {
    if (this.dropdown) this.dropdown.style.display = "none";
    this._open = false;
  }

  _esc(s) {
    const d = document.createElement("div");
    d.textContent = String(s ?? "");
    return d.innerHTML;
  }
}
